import { useEffect, useRef } from 'react'

// Calls `callback` every `delay` ms. Pass delay = null to pause (e.g. stop
// polling once an assessment is no longer active). The latest callback is
// always used without resetting the timer. Ticks are skipped while the tab is
// hidden, and the callback runs once when the tab becomes visible again.
export function useInterval(callback: () => void, delay: number | null) {
  const saved = useRef(callback)

  useEffect(() => {
    saved.current = callback
  }, [callback])

  useEffect(() => {
    if (delay === null) return
    const id = setInterval(() => {
      if (!document.hidden) saved.current()
    }, delay)
    const onVisible = () => {
      if (!document.hidden) saved.current()
    }
    document.addEventListener('visibilitychange', onVisible)
    return () => {
      clearInterval(id)
      document.removeEventListener('visibilitychange', onVisible)
    }
  }, [delay])
}
